import React, { Component } from 'react'
import { Spin, Timeline } from 'antd'
import _ from 'lodash'
import ListAIA from './ListAIA'
import ListPaymentRequests from './ListPaymentRequests'
import ListInvoices from './ListInvoices'
import ListMaterialRequests from './ListMaterialRequests'
import ListWorkOrders from './ListWorkOrders'
import ListDriverRequests from './ListDriverRequests'
import ListChangeOrderEstimates from './ListChangeOrderEstimates'
import ListRepairOrderEstimates from './ListRepairOrderEstimates'
import ListChangeOrder from './ListChangeOrder'
import ListRepairOrder from './ListRepairOrders'
import ListTransmittals from './ListTransmittals'
import ListRfis from './ListRfis'
import ListServiceOrders from './ListServiceOrders'

class ListItems extends Component {
  iterateJobs = () => {
    const { fullReport } = this.props
    return fullReport.map((job, index) => {
      const aias = _.get(job, 'openItems.aias')
      const paymentRequests = _.get(job, 'openItems.paymentRequests')
      const invoices = _.get(job, 'openItems.invoices')
      const materialRequests = _.get(job, 'openItems.materialRequests')
      const workOrders = _.get(job, 'openItems.workOrders')
      const driverRequests = _.get(job, 'openItems.driverRequests')
      const changeOrderEstimates = _.get(job, 'openItems.changeOrderEstimates')
      const repairOrderEstimates = _.get(job, 'openItems.repairOrderEstimates')
      const changeOrders = _.get(job, 'openItems.changeOrders')
      const repairOrders = _.get(job, 'openItems.repairOrders')
      const transmittals = _.get(job, 'openItems.transmittals')
      const serviceOrders = _.get(job, 'openItems.serviceOrders')
      const rfis = _.get(job, 'openItems.rfis')

      return (
        job.openItems.hasOpenItems && (
          <Timeline.Item key={job.id} style={{ marginBottom: 20 }}>
            <h5>{job.name}</h5>
            {/* AIAs */}
            {aias && aias.length > 0 && <ListAIA aias={aias} />}
            {/* Payment Requests */}
            {paymentRequests &&
              paymentRequests.length > 0 && (
                <ListPaymentRequests paymentRequests={paymentRequests} />
              )}

            {/* Invoices */}
            {invoices && invoices.length > 0 && <ListInvoices invoices={invoices} />}
            {/* Material Requests */}
            {materialRequests &&
              materialRequests.length > 0 && (
                <ListMaterialRequests materialRequests={materialRequests} />
              )}
            {/* Work Orders */}
            {workOrders && workOrders.length > 0 && <ListWorkOrders workOrders={workOrders} />}
            {/* Driver Requests */}
            {driverRequests &&
              driverRequests.length > 0 && <ListDriverRequests driverRequests={driverRequests} />}
            {/* Change Order Estimates */}
            {changeOrderEstimates &&
              changeOrderEstimates.length > 0 && (
                <ListChangeOrderEstimates changeOrderEstimates={changeOrderEstimates} />
              )}
            {/* Repair Order Estimates */}
            {repairOrderEstimates &&
              repairOrderEstimates.length > 0 && (
                <ListRepairOrderEstimates repairOrderEstimates={repairOrderEstimates} />
              )}
            {/* Change Order */}
            {changeOrders &&
              changeOrders.length > 0 && <ListChangeOrder changeOrders={changeOrders} />}
            {/* Repair Order */}
            {repairOrders &&
              repairOrders.length > 0 && <ListRepairOrder repairOrders={repairOrders} />}
            {/* Transmittals */}
            {transmittals &&
              transmittals.length > 0 && <ListTransmittals transmittals={transmittals} />}
            {/* RFIs */}
            {rfis && rfis.length > 0 && <ListRfis rfis={rfis} />}
            {/* Service Orders */}
            {serviceOrders &&
              serviceOrders.length > 0 && <ListServiceOrders serviceOrders={serviceOrders} />}
          </Timeline.Item>
        )
      )
    })
  }
  render() {
    const { loadingFullReport, fullReport } = this.props
    return (
      <div>
        {loadingFullReport && <Spin />}
        {!loadingFullReport &&
          fullReport && (
            <div>
              <h4>Jobs</h4>
              <Timeline>{this.iterateJobs(fullReport)}</Timeline>
            </div>
          )}
      </div>
    )
  }
}

export default ListItems



// WEBPACK FOOTER //
// ./src/components/reports/general/open-items/ListItems.js